
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.5 7.25a1 1 0 00-1 1v15.151a1 1 0 001 1h7.35c.563 0 1.107.229 1.512.643.406.416.638.984.638 1.581a1 1 0 102 0c0-.597.232-1.165.638-1.58.405-.415.95-.644 1.512-.644h7.35a1 1 0 001-1V8.25a1 1 0 00-1-1h-6.3a5.152 5.152 0 00-3.685 1.56c-.188.192-.36.398-.515.614a5.268 5.268 0 00-.515-.614A5.152 5.152 0 0012.8 7.25H6.5zM18 23.012a4.096 4.096 0 012.15-.61h6.35V9.25h-5.3c-.841 0-1.653.342-2.255.958a3.35 3.35 0 00-.945 2.34v10.464zm-2 0V12.548a3.35 3.35 0 00-.945-2.34A3.152 3.152 0 0012.8 9.25H7.5v13.151h6.35c.766 0 1.508.216 2.15.611z","fill":"currentColor"}})])
          )
        }
      }
    